// extracted by mini-css-extract-plugin
module.exports = {"vertical":"form-input-group_vertical__1ai8P","horizontal":"form-input-group_horizontal__3a-D4","largeGap":"form-input-group_largeGap__1L-vz"};